import { RelayPatchCachingServersController } from '../controller/RelayPatchCachingServersController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { DataGridItem, EVENTS } from '../types';

export class RelayPatchCachingServersWebComponent extends BaseWebComponentElement {
  public controller: RelayPatchCachingServersController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: RelayPatchCachingServersController,
    });
  }

  relayCachingServersAttributeName = 'data-relay-caching-servers';

  get cachingServers(): DataGridItem[] {
    const attributeValue = this.getAttribute(this.relayCachingServersAttributeName);
    return attributeValue ? JSON.parse(attributeValue) : [];
  }

  set cachingServers(data: DataGridItem[]) {
    this.setAttribute(this.relayCachingServersAttributeName, JSON.stringify(data));

    if (this.controller) {
      this.controller.clearInputSelector(this.controller.view.dom.$searchInput);

      if (this.controller.view.dom.$gridView) {
        // Re-render grid
        this.controller.view.dom.$gridView.propertiesSet = true;
      }
    }

    // trigger CACHING_SERVERS_NUMBER_UPDATED event
    this.dispatchEvent(
      new CustomEvent(EVENTS.CACHING_SERVERS_NUMBER_UPDATED, {
        detail: {},
        bubbles: true,
      })
    );
  }

  get disabled(): boolean {
    const attributeValue = this.getAttribute('disabled');

    if (attributeValue !== null) {
      return true;
    }

    return false;
  }

  set disabled(value: boolean) {
    if (value) {
      this.setAttribute('disabled', 'true');
    } else {
      this.removeAttribute('disabled');
    }
  }

  get companyId(): string {
    const value = this.getAttribute('data-companyId');

    if (value === null) {
      return '';
    }

    return value;
  }

  set companyId(value: string) {
    this.setAttribute('data-companyId', value);
  }
}
